<i class="i shape rotate" [ngStyle]="{ height, width }"></i>
